/**
 * Build deep links to Governance module
 */

export function buildGovernanceDeepLink(params: {
  tab?: 'policies' | 'processes' | 'evidence' | 'roles';
  search?: string;
}): string {
  const { tab, search } = params;
  const base = '/governance';
  if (!tab && !search) return base;

  const tabRoutes: Record<string, string> = {
    policies: '/governance/policies',
    processes: '/governance/overview',
    evidence: '/governance/evidence',
    roles: '/governance/overview',
  };
  const path = tab ? (tabRoutes[tab] ?? base) : base;
  if (search && search.trim()) {
    return `${path}?search=${encodeURIComponent(search.trim())}`;
  }
  return path;
}
